export { goNative } from './native.js';
